import React, { useState, useEffect } from 'react';
import './resources.scss';

export interface Feature {
  attributes: {
    objectid: number;
    category: string;
    description: string;
    linkname: string;
    url: string;
  };
}

export interface Features {
  features: Array<Feature>;
}

interface SortedList {
  listed: { [index: string]: Array<Feature> };
  unlisted: Array<Feature>;
}

export function Resources({
  setIsResourcesOpen,
  resourceList,
}: {
  setIsResourcesOpen: Function;
  resourceList: Features;
}) {
  const [updatedList, setUpdatedList] = useState<SortedList | null>(null);

  const sortedList = () => {
    return resourceList.features.reduce(
      (acc: any, cur) => {
        if (!cur.attributes.description && !cur.attributes.linkname) return acc;
        if (!cur.attributes.category) {
          acc['unlisted'] = [...acc['unlisted'], cur];
        } else {
          acc.listed[cur.attributes.category] = !acc.listed[cur.attributes.category] ? [cur] : [...acc.listed[cur.attributes.category], cur];
        }
        return acc;
      },
      { listed: {}, unlisted: [] }
    );
  };

  useEffect(() => {
    setUpdatedList({ ...sortedList() });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='resources-modal modal'>
      <div className='title'>
        <h1 className='main-title'>Resources</h1>
        <svg
          name='closeIcon'
          onClick={() => setIsResourcesOpen(false)}
          preserveAspectRatio='xMidYMin meet'
          fill='#f26957'
          viewBox='0 0 387 387'
          width='15px'
          height='15px'
        >
          <path d='M387 46L341 0 193 148 46 0 0 46l148 147L0 341l46 46 147-148 148 148 46-46-148-148z'></path>
        </svg>
      </div>
      {updatedList && (
        <div className='resources'>
          {Object.keys(updatedList['listed']).length > 0 &&
            Object.keys(updatedList['listed']).map((key: string) => {
              return (
                <div className='resource-section'>
                  <h3>{key}</h3>
                  <div>
                    {Object.keys(updatedList.listed).length > 0 &&
                      updatedList['listed'][key].map((el: Feature) => {
                        return (
                          <div className='feature-item'>
                            <a href={el.attributes.url}>{el.attributes.linkname}</a>
                            <p>{el.attributes.description}</p>
                          </div>
                        );
                      })}
                  </div>
                </div>
              );
            })}
          {updatedList.unlisted.map((el: Feature) => {
            return (
              <div className='feature-item'>
                <a href={el.attributes.url}>{el.attributes.linkname}</a>
                <p>{el.attributes.description}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
